/* Manne 2026-11-03: buscar con foto -> Thony. No envia nada solo; el cliente toca enviar. */
(function () {
  var TEXT = '📷 ¿Tienen algo como esto?';
  var OK = /^image\/(jpeg|png|webp)$/;
  function closeDrawer() {
    var c = document.querySelector('.yv-search-drawer-close');
    if (c) { try { c.click(); } catch (e) {} }
  }
  function note(msg) {
    var el = document.getElementById('manne-ph-note');
    if (!el) { el = document.createElement('div'); el.id = 'manne-ph-note'; el.setAttribute('role', 'status');
      el.style.cssText = 'position:fixed;left:50%;bottom:96px;transform:translateX(-50%);max-width:90vw;padding:10px 16px;border-radius:10px;background:#111;color:#fff;font:14px sans-serif;z-index:2147483002;box-shadow:0 2px 10px #0004';
      document.body.appendChild(el); }
    el.textContent = msg; el.hidden = false;
    clearTimeout(el._t); el._t = setTimeout(function () { el.hidden = true; }, 5000);
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-manne-ph-open]');
    if (!b) return;
    e.preventDefault();
    var form = b.closest('form') || document;
    var inp = form.querySelector('[data-manne-ph-input]');
    if (inp) { inp.value = ''; inp.click(); }
  });
  document.addEventListener('change', function (e) {
    var inp = e.target;
    if (!inp.matches || !inp.matches('[data-manne-ph-input]')) return;
    var f = inp.files && inp.files[0];
    if (!f) return;
    if (!OK.test(f.type || '')) { note('Esa foto no se puede usar. Prueba con una foto JPG o PNG.'); return; }
    if (typeof window.thonyOpenWithPhoto !== 'function') { note('El chat no está disponible ahora mismo. Intenta de nuevo en un momento.'); return; }
    closeDrawer();
    window.thonyOpenWithPhoto(f, TEXT).then(function (attached) {
      if (!attached) note('Toca el clip 📎 en el chat para adjuntar tu foto.');
    }).catch(function () { note('No pude abrir el chat. Intenta de nuevo en un momento.'); });
  });
})();
